import type { CSSProperties } from "react";

import type { IconName } from "@similarweb/icons";

import type { FormattedNumber, SearchKeywordsData, BrandedSplitData } from "../../types";
import type { JSX } from "react";

export const enum SearchMetricName {
    ALL = "all",
    ORGANIC = "organic",
    PAID = "paid",
    PPC = "ppcSpend",
    BRANDED = "branded",
    RANK_POSITION = "rankPosition",
}

interface GraphData {
    data: number[][];
    isEmpty: boolean;
}

interface WidgetData {
    domain: string;
}
interface SearchWidgetData extends WidgetData {
    title: string;
    change: number;
    description: FormattedNumber;
}

export interface SearchTrafficData extends SearchWidgetData {
    graph?: GraphData;
    keywordsData?: SearchKeywordsData;
    totalVisits?: number;
}

export interface SearchRankPositionData extends SearchWidgetData {
    country: number;
}

export interface SearchPieChartData extends WidgetData {
    chartData: BrandedSplitData;
    isEmpty: boolean;
}
export interface SearchMetricData {
    [SearchMetricName.ALL]: { [key: string]: SearchTrafficData };
    [SearchMetricName.ORGANIC]: { [key: string]: SearchTrafficData };
    [SearchMetricName.PAID]: { [key: string]: SearchTrafficData };
    [SearchMetricName.PPC]: { [key: string]: SearchTrafficData };
    [SearchMetricName.BRANDED]: { [key: string]: SearchPieChartData };
    [SearchMetricName.RANK_POSITION]: { [key: string]: SearchRankPositionData };
}

export type IconButtonHref = {
    name: IconName;
    href: string;
    eventSubName: string;
};

export interface ConfigSchema {
    name: SearchMetricName;
    title: string;
    tooltipText: string;
    component: React.ComponentType<{
        data: SearchTrafficData | SearchRankPositionData | SearchPieChartData;
        descriptionText?: string;
        isKeywordsLoading?: boolean;
    }>;
    valueFormatter?: (value: number) => string;
    noDataStateOnError?: JSX.Element;
    iconButtonHref?: IconButtonHref;
    styles?: CSSProperties;
    descriptionText?: string;
}

export type WidgetsConfigSchema = {
    [key in SearchMetricName]: ConfigSchema;
};
